import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Seo, breadcrumbJsonLd } from '@/components/Seo';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { SERVICES, SITE } from '@/data/site-config';

export default function ServicesHub() {
  return (
    <>
      <Seo
        title="Services"
        description={`Personal training, semi-private training, nutrition coaching, golf fitness, and online fitness coaching in ${SITE.city}, FL.`}
        canonical="/services"
        jsonLd={breadcrumbJsonLd([{ name: 'Home', path: '/' }, { name: 'Services', path: '/services' }])}
      />
      <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Services', path: '/services' }]} />
      <section className="container-x py-12">
        <span className="eyebrow">Services</span>
        <h1 className="font-display text-4xl md:text-5xl font-bold mt-3">Personal coaching, built for you.</h1>
        <p className="mt-4 text-[color:var(--ft-muted)] text-lg max-w-3xl">Pick the type of coaching that fits your life. Every service is delivered with the same private-studio standard — real attention, real programming, real accountability.</p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-8">
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="surface card-hover p-6 block" data-testid={`hub-${s.slug}`}>
              <h2 className="font-display text-xl font-semibold mb-1">{s.title}</h2>
              <p className="text-[color:var(--ft-muted)] text-sm leading-relaxed">{s.short}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-accent">Learn more <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
